import { useLanguage } from '@/shared/contexts/LanguageContext';
import type { SupportedLanguages } from '@/i18n/i18next';

export const useLocaleDateString = () => {
  const { language } = useLanguage();

  const toLocaleDateString = (
    date: string,
    options?: Intl.DateTimeFormatOptions
  ): string => {
    const dateObj = new Date(date);

    const localeMap: Record<SupportedLanguages, string> = {
      en: 'en-US',
      he: 'he-IL',
    };

    const locale = localeMap[language] || 'en-US';

    return dateObj.toLocaleDateString(locale, options);
  };

  return { toLocaleDateString };
};
